import { EnrichmentPipeSet, TrackerConfigurations, TransformPipeSet } from '@pulse/common';
import { PipeHost } from '../pipe';
import {
    ActionParamEventPipe,
    AttributeSpreadPipe,
    ChangedAttributesPipe,
    EventGlobalsPipe,
    LegacySourcePipe,
    NavigationEventPipe,
} from '../pipes';

export class PipesFactory {
    constructor(
        private attributeSpreadPipe: AttributeSpreadPipe,
        private actionParamEventPipe: ActionParamEventPipe,
        private navigationEventPipe: NavigationEventPipe,
        private changedAttributesPipe: ChangedAttributesPipe,
        private eventGlobalsPipe: EventGlobalsPipe,
        private sourcePipe: LegacySourcePipe,
        private pipesHost: PipeHost,
        private defaultPipesHost: PipeHost,
        private config: TrackerConfigurations,
    ) {}

    registerPipes() {
        const transformPipes: TransformPipeSet[] = this.config.transformPipes || [];
        const enrichmentPipes: EnrichmentPipeSet[] = this.config.enrichmentPipes || [];

        const defaultTransformPipes: TransformPipeSet[] = [
            {
                selector: 'attribute',
                use: [this.attributeSpreadPipe, this.changedAttributesPipe],
            },
            {
                selector: 'event',
                use: [this.actionParamEventPipe, this.navigationEventPipe],
            },
        ];

        const defaultEnrichmentPipes: EnrichmentPipeSet[] = [
            {
                selector: 'event',
                use: [this.eventGlobalsPipe, this.sourcePipe],
            },
        ];

        //
        // Register
        ////////////////////////////

        defaultTransformPipes.forEach((pipe) => this.defaultPipesHost.registerTransformSet(pipe));
        defaultEnrichmentPipes.forEach((pipe) => this.defaultPipesHost.registerEnrichmentSet(pipe));

        transformPipes.forEach((pipe) => this.pipesHost.registerTransformSet(pipe));
        enrichmentPipes.forEach((pipe) => this.pipesHost.registerEnrichmentSet(pipe));
    }
}
